let storage = window.localStorage

function guid() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
        s4() + '-' + s4() + s4() + s4();
}

export const saveName = (name) => {
    storage.setItem('name', name);
}

export const getName = () => {
    return storage.getItem('name')
}

export const setUuid = (uuid) => {
    storage.setItem('uuid', uuid);
}

export const createUUID = () => {
    if (!getUUID()) {
        storage.setItem('uuid', guid())
    }

}

export const getUUID = () => {
    return storage.getItem('uuid')
}

export const clearUUID = () => {
    storage.removeItem('uuid');
}

export const clearLocalStorage = () => {
    storage.removeItem('name');
    storage.removeItem('uuid');
    storage.removeItem('groupName');
}

export const saveGroupName = (groupName) => {
    storage.setItem('groupName', groupName);
}

export const getGroupName = () => {
    return storage.getItem('groupName')
}

export const getAllInfo = () => {
    return Boolean(getName() && getUUID() && getGroupName());
}


// WEBPACK FOOTER //
// ./src/App/api/localstorage.js